import { utcToJSDate } from "@/utils/date-time";
import { City } from "./city.model";
import { LatLng, PaginationFilterRequest } from "./core.model";
import { Country } from "./country.model";
import { UserLookup } from "./user.model";

export function activityFromJson (json: any): ActivityInfo {
  return {
    ...json,
    startTime: utcToJSDate(json.startTime)!
  } as ActivityInfo;
};

export interface ActivityInfo {
    id: number;
    userId: number;
    user: UserLookup;
    cityId?: number;
    city?: City;
    countryId?: number;
    country?: Country;
    distanceInMeter: number;
    duration: number;
    startTime: Date;
    providerId: number;
    provider: ActivityProviderEnum;
    activityType?: ActivityTypeEnum;
    sportType?: SportTypeEnum;
    route?: LatLng[];
    runningClubEventId?: number;
}

export interface UpsertActivityInfo {
    id?: number;
    userId?: number;
    cityId?: number;
    countryId?: number;
    distanceInMeter?: number;
    duration?: number;
    startTime?: Date;
    providerId?: number;
    Provider?: ActivityProviderEnum;
    sportType?: SportTypeEnum;
}

export class ActivityInfoPaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    countryId?: number;
    userId?: number;
    runningClubEventId?: number;
    hasRoute?: boolean;
    type?: ActivityTypeEnum;
}


export enum ActivityProviderEnum
{
    Strava = 1
}

export const ActivityProviderList =
[
    { value: 1, label: "Strava" },
];

export enum ActivityTypeEnum
{
    Training = 1,
    Marathon = 2,
    Commute = 3,
    Event = 4,
    ClubRun = 5,
}

export const ActivityTypeList =
[
    { value: 1, label: "Training" },
    { value: 2, label: "Marathon" },
    { value: 3, label: "Commute" },
    { value: 4, label: "Event" },
    { value: 5, label: "ClubRun" },
];

export enum SportTypeEnum
{
    Walk = 1,
    Run = 2
}

export const SportTypeList =
[
    { value: 1, label: "Walk" },
    { value: 2, label: "Run" },
];